import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { GlobalComponent } from 'src/app/global/global.component';
import { GetEngagement } from './engagement.modal';

@Injectable({
    providedIn: 'root'
})
export class EngagementService extends Subject<DataStateChangeEventArgs>{
    constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent
    ) {
      super()
    }
    public outputValues(state : GetEngagement): void{
        this.getEngagementList(state).subscribe(x=>super.next(x));
    }
    getEngagementList(state : GetEngagement): Observable<DataStateChangeEventArgs>{
        return this.http.post<any>("api/EngagementLogs/GetEngagementList",state)
        .pipe(map(
            (response:any)=>
                <any>{
                    result: response['result'],
                    count: response['count'],
                }
        )).pipe(map((e: any) => {
            e?.result?.forEach((ele) => {
            })
            return e;
          }))
    }
    getFilterList(): Observable<any> {
        let url = "api/EngagementLogs/GetEnagagementLogFilterList";
        return this.http.get<any>(url, { observe: 'response' }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        )
      }
}